import { Block, Text } from '@snowflake/core-ui';
import * as React from 'react';
import { useSignupPageContext } from '../../pages/SignupContext';

export const SubtitleHeading = () => {
  const { renderingOptions } = useSignupPageContext();
  const textColor = '#1E252F' as any;

  const heading = React.useMemo(() => {
    return renderingOptions.mainMarketingTitle ?? <></>;
  }, [renderingOptions.mainMarketingTitle]);

  const subtitle = React.useMemo(() => {
    return renderingOptions.subtitleHeading ?? <></>;
  }, [renderingOptions.subtitleHeading]);

  return (
    <Block marginBottom={32}>
      <Text fontSize={28} color={textColor} lineHeight="34px" weight="bold" paddingBottom={8}>
        {heading}
      </Text>
      <Text fontSize={16} color={textColor} lineHeight="20px" weight="semi-bold">
        {subtitle}
      </Text>
    </Block>
  );
};
